// Cloudflare Turnstile loader shared by the public forms (report a server, early access).
const TURNSTILE_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

export function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src^="https://challenges.cloudflare.com/turnstile"]`);
    const s = existing || document.createElement("script");
    s.addEventListener("load", () => resolve(window.turnstile));
    s.addEventListener("error", () => reject(new Error("could not load the human-verification widget")));
    if (!existing) { s.src = TURNSTILE_SRC; s.async = true; document.head.appendChild(s); }
  });
}

export const turnstileTheme = () => (document.documentElement.getAttribute("data-theme") === "light" ? "light" : "dark");
